import { PivotTableProps } from 'components/pivot-table/PivotTable'

import { KeyMapping, keyMappings } from '../common/keyMapping-relatorioGerencial'
import { VisibilidadeModeloPersonalizadoEnum } from '../components/modelo-personalizado/form/model-modeloPersonalizadoRelatorioGerencialForm'
import { SimNaoRelatorioGerencialSelectFieldDocument } from './../../../../graphql/hooks.generated'
import { RelatorioGerencialAtendimentoProfissionalModel } from './model-relatorioGerencialAtendimentoProfissional'

const atendimentoCompartilhadoLotacao: KeyMapping = {
  keyName: 'Atendimento compartilhado',
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: SimNaoRelatorioGerencialSelectFieldDocument,
  },
}

export const atendimentoProfissionalKeyMapping: PivotTableProps<
  RelatorioGerencialAtendimentoProfissionalModel
>['keyMapping'] = new Map<keyof RelatorioGerencialAtendimentoProfissionalModel, KeyMapping>([
  ['uf', keyMappings.uf],
  ['municipio', keyMappings.municipio],
  ['unidadeSaude', keyMappings.unidadeSaude],
  ['equipe', keyMappings.equipe],
  ['tipoAtendimento', keyMappings.tipoAtendimento],
  ['nomeProfissional', keyMappings.nomeProfissional],
  ['turno', keyMappings.turno],
  ['mes', keyMappings.mes],
  ['sexo', keyMappings.sexo],
  ['dia', keyMappings.dia],
  ['diaDaSemana', keyMappings.diaDaSemana],
  ['hora', keyMappings.hora],
  ['tipoConsulta', keyMappings.tipoConsulta],
  ['atendimentoCompartilhadoLotacao', atendimentoCompartilhadoLotacao],
  ['categoriaProfissional', keyMappings.categoriaProfissional],
  ['semana', keyMappings.semana],
  ['faixaEtaria', keyMappings.faixaEtaria],
  ['cbo', keyMappings.cbo],
  ['producoes', keyMappings.producoes],
])
